import React, { useEffect, useState } from "react";
import { api, arabicError } from "../lib/api";
import { toast } from "sonner";
import { Trash2, Eye, Clock, Film } from "lucide-react";

const AdminStories = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [includeExpired, setIncludeExpired] = useState(false);
  const [viewing, setViewing] = useState(null);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get(`/admin/stories?include_expired=${includeExpired}`); setItems(r.data || []); }
    catch (e) { toast.error(arabicError(e)); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [includeExpired]); // eslint-disable-line

  const del = async (id) => {
    if (!window.confirm("حذف هذا الستوري؟")) return;
    try { await api.delete(`/stories/${id}`); toast.success("تم الحذف"); load(); }
    catch (e) { toast.error(arabicError(e)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-stories-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#333333] flex items-center gap-2">
            <Film className="text-[#09637E]" size={32} /> الحالات (الستوري)
          </h1>
          <p className="text-[#666666] mt-1">جميع ستوري التجار — اضغط للعرض أو الحذف</p>
        </div>
        <label className="flex items-center gap-2 text-sm font-bold text-[#333333]">
          <input type="checkbox" checked={includeExpired} onChange={(e) => setIncludeExpired(e.target.checked)} data-testid="include-expired" />
          يشمل المنتهية
        </label>
      </div>

      {loading ? (
        <div className="text-center text-[#666666] py-12">جارٍ التحميل...</div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-[#7AB2B2] rounded-2xl p-12 text-center">
          <Film className="mx-auto text-[#7AB2B2] mb-3" size={48} />
          <p className="text-[#666666] font-bold text-lg">لا توجد ستوري حالياً</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {items.map((s) => (
            <div key={s.id} className="bg-white border border-[#7AB2B2] rounded-xl overflow-hidden" data-testid={`admin-story-${s.id}`}>
              <button onClick={() => setViewing(s)} className="w-full">
                <img src={s.image_url} alt="" className="w-full h-40 object-cover" />
              </button>
              <div className="p-2 text-xs">
                <div className="font-bold text-[#333333] truncate">{s.merchant_name}</div>
                <div className="flex items-center gap-1 text-[#666666] mt-1">
                  <Eye size={12} /> {s.view_count} <Clock size={12} className="mr-2" />
                  {s.is_active ? "نشط" : "منتهي"}
                </div>
                <button onClick={() => del(s.id)} data-testid={`admin-delete-story-${s.id}`}
                  className="mt-2 w-full h-8 rounded border-2 border-red-500 text-red-500 hover:bg-red-50 font-bold text-xs flex items-center justify-center gap-1">
                  <Trash2 size={12} /> حذف
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {viewing && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" onClick={() => setViewing(null)}>
          <button onClick={() => setViewing(null)} className="absolute top-4 left-4 w-11 h-11 rounded-full bg-white/90 flex items-center justify-center font-extrabold">✕</button>
          <div className="max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <img src={viewing.image_url} alt="" className="max-h-[85vh] w-full object-contain rounded-lg" />
            <div className="mt-3 text-white text-center text-sm bg-black/50 rounded-lg p-2">
              <div className="font-bold">{viewing.merchant_name}</div>
              {viewing.caption && <div className="mt-1">{viewing.caption}</div>}
              <div className="mt-1 opacity-80">{viewing.view_count} مشاهدة · {viewing.is_active ? "نشط" : "منتهي"}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminStories;
